import React, {useEffect, useState } from "react";
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import DeleteRoutine from '../api/DeleteRoutine';
import Form from 'react-bootstrap/Form';
import GetAllActivities from "../api/Activities";

import 
    GetAllPublicRoutinesByUser
from '../api/MyRoutines';

import "./MyRoutines.css";
import PostRoutine from '../api/RoutinesPost'
import GetAllRoutines from "../api/Routines";
import Axios from "axios";
const BASE = 'https://fitnesstrac-kr.herokuapp.com/api';
const MyRoutines  = (props) => {

    const [routineName, setRoutineName] = useState("");
    const [goalName, setGoalName] = useState("");

    const {routine, setRoutine, activity, setActivity, deletedRoutine, setDeletedRoutine, user, setUser, setToken, token} = props 

    useEffect( () => {
        
        GetAllPublicRoutinesByUser({user, token}).then({setRoutine})
        GetAllActivities().then(setActivity)
        
        
    },[])

    useEffect( () => {
        
        GetAllPublicRoutinesByUser({user, token}).then({setRoutine})
        
    },[setRoutine]);
   
            return ( <>
                                <Form>
                    <Form.Group controlId="formBasicEmail">
                        <Form.Label>&nbsp;&nbsp;&nbsp;Routine Name:</Form.Label>
                        <Form.Control type="text" placeholder="Routine name" value={routineName} onChange={(event )=> {
                            event.preventDefault();
                        let routineName = event.target.value;
                       
                         return setRoutineName(routineName);
                        }} />
                        <Form.Text className="text-muted">
                        Name your Routine so we can get to it!
                        </Form.Text>
                    </Form.Group>

                    <Form.Group controlId="formBasicPassword">
                        <Form.Label>&nbsp;&nbsp;&nbsp;Routine Goal:</Form.Label>
                        <Form.Control type="text" placeholder="Routine goal" value={goalName} onChange={(event )=> {
                            event.preventDefault();
                            let goalName = event.target.value;
                            
                            return setGoalName(goalName)
                        }}/>
                    </Form.Group>
                    <Form.Group controlId="formBasicCheckbox">
                        <Form.Check type="checkbox" label="Make public?" />
                    </Form.Group>
                    <Button variant="primary" type="submit" value={routineName, routine, user, goalName, token} onClick={ async (event) => {
                        event.preventDefault();
                        
                        try {
                        
                        const routine = await PostRoutine({ creatorId : user.id, isPublic : true, routineName, goalName, token, user })
                        
                        } catch (error) {
                            console.error(error)
                        } finally {
                            await GetAllRoutines().then(setRoutine);
                        }
                    }}>
                        Post
                    </Button>
                    </Form>
                
                { routine && routine.map(({ id, creatorId, isPublic, name, goal, activities }) => {
                    
                    return (user.id === creatorId ? 
                    <div key={id} style={{border :  '8px double black',
                    width: '380px',
                    letterSpacing: '3px'}}>
                  
                        <div class="card-body">
                        <h5 class="card-title">{name}</h5>
                  <h6 class="card-subtitle mb-2 text-muted">{goal}</h6>
                  
                  <DropdownButton id="dropdown-basic-button" title="Add Activity" value={activity, routine, token} >
                     
                        
                     {activity && activity.map((activity, index) => {

                     return ( <>
                     <Dropdown.Item href="#/action-1" onClick={async (event)=> {
                            event.preventDefault()
                            const body = {
                                activityId: activity.id,
                                count: activity.count,
                                duration: activity.duration
                                
                            }
                        
                            const headers = { 'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`}

                            try {
                                const response = await Axios.post(`${BASE}/routines/${id}/activities`, body, headers)
                                
                                
                            } catch (error) {
                                console.error(error)
                            } finally {
                                GetAllRoutines().then(setRoutine)
                            }
                            
                     }}>{activity.name}</Dropdown.Item>
                     </>)
                     
                     })}
                     </DropdownButton>
                        <a href="#" class="btn btn-primary" onClick={() => {

                        }}>EDIT</a>
                        <a href="#" class="btn btn-danger" value={token} routine={routine} onClick={ async (event) => {
                            try {
                                
                                event.preventDefault();
                                const deletedRoutine = await DeleteRoutine(id, token)
                                
                                return setDeletedRoutine(deletedRoutine);
                                
                                
                            } catch (error) {
                                console.error(error)
                            } finally {
                                await GetAllRoutines().then(setRoutine);
                            }
                        }}>DELETE</a>
                        
                        <p class="card-text">{isPublic === true ? <span>This routine is public.</span> : <span>Private routine</span>}</p>
                        </div>
                    </div> : "")
                })}
                
                </>)
        
         
    
    

};
export default MyRoutines;